const lockCar = () => import('@/pages/lockCar')
const unlock = () => import('@/pages/lockCar/common/unlock.vue')
const relieve = () => import('@/pages/lockCar/common/relieve.vue')
export default [
  {
    path: '/lockCar',
    name: 'LockCar',
    component: lockCar,
    meta: {
      storeKey: '*'
    }
  },
  {
    path: '/lockCar/unlock',
    name: 'Unlock',
    component: unlock,
    meta: {
      storeKey: '*'
    }
  },
  {
    path: '/lockCar/relieve',
    name: 'Relieve',
    component: relieve,
    meta: {
      storeKey: '*'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/lockCar/index.js